import { getActiveLocaleSelector, getTenancySelector } from '@americanexpress/travel-selectors';
import { addErrorToReport, loadLanguagePack } from '@americanexpress/one-app-ducks';
import { composeModules } from 'holocron';
import { isConditionalFeature } from '@americanexpress/conditional-features';
import { oneErrorOnNotOkFetchye, replaceDomainForCacheKey } from '@americanexpress/fetchye-amex';
import { getPrefetchedExperimentsSelector } from '../selectors/getPrefetchedExperimentsSelector';
import { DISABLE_PACKAGES_FF } from '../constants/oneXpConstants';
import { loadMembershipDomain } from './loadMembership';
import {
  MODULE_NAME,
  SEARCH_MODULE_NAME,
  TERMS_MODULE_NAME,
  ADVISORY_MODULE_NAME,
  ADS_MODULE_NAME,
  CREDIT_MODULE_NAME,
  LEGAL_MODULE_NAME,
  FOOTER_MODULE_NAME,
  PERSONALIZED_MAKETING_ARTICLES_MODULE_NAME,
} from '../constants/modules';
import { oneCmsReporting } from '../fetchye/useOneCmsFetchye';
import {
  hasFooterLinksRule, hasLegalRule,
  hasProjectAdsRule, hasTravelCreditOverlayRule, hasForYouRule,
  hasDisablePackagesRule,
} from '../constants/featureRulesConstants';
import getLineOfBusinessFromPath from '../utils/getLineOfBusinessUtils';
import { getHomepageOneCmsUrl, getTravelFeatureFlagsOneCmsUrl } from '../selectors/getOneCmsJsonSelectors';

export const loadModuleData = async ({ store, ownProps }) => {
  const { dispatch, getState } = store;
  const state = getState();
  const tenancy = getTenancySelector(state);
  const locale = getActiveLocaleSelector(state);
  const oneCmsHomepageUrl = getHomepageOneCmsUrl(getState());
  const oneCmsFeatureFlagUrl = getTravelFeatureFlagsOneCmsUrl(getState());
  const experiments = getPrefetchedExperimentsSelector(state);
  const isPackagesDisabledByRule = isConditionalFeature(hasDisablePackagesRule, state);
  const isPackagesDisabledByFF = experiments
    ?.[DISABLE_PACKAGES_FF]?.dimensions?.[tenancy]?.includes(locale);
  const isPackagesDisabled = isPackagesDisabledByRule || isPackagesDisabledByFF;

  const activeTab = getLineOfBusinessFromPath(
    isPackagesDisabled,
    ownProps?.location?.pathname
  );

  try {
    const resolution = await Promise.allSettled([
      dispatch(loadMembershipDomain(state)),
      dispatch(loadLanguagePack(MODULE_NAME, { fallbackLocale: 'en-US' })),
      dispatch(oneErrorOnNotOkFetchye(oneCmsHomepageUrl, {
        mapKeyToCacheKey: replaceDomainForCacheKey('oneCMS'),
      }, oneCmsReporting)),
      dispatch(oneErrorOnNotOkFetchye(oneCmsFeatureFlagUrl, {
        mapKeyToCacheKey: replaceDomainForCacheKey('oneCMS'),
      }, oneCmsReporting)),
      dispatch(composeModules([
        {
          name: SEARCH_MODULE_NAME,
          props: { activeTab },
        },
        {
          name: TERMS_MODULE_NAME,
          props: { programs: ['homepage'] },
        },
        {
          name: ADVISORY_MODULE_NAME,
        },
        {
          name: PERSONALIZED_MAKETING_ARTICLES_MODULE_NAME,
          props: {
            clientId: 'homepage',
            placementId: 'get-inspired',
          },
        },
        ...isConditionalFeature(hasForYouRule, state) ? [{
          name: PERSONALIZED_MAKETING_ARTICLES_MODULE_NAME,
        }] : [],
        ...isConditionalFeature(hasProjectAdsRule, state) ? [{
          name: ADS_MODULE_NAME,
        }] : [],
        ...isConditionalFeature(hasTravelCreditOverlayRule, state) ? [{
          name: CREDIT_MODULE_NAME,
          props: { isOverlay: true },
        }] : [],
        ...isConditionalFeature(hasLegalRule, state) ? [{
          name: LEGAL_MODULE_NAME,
        }] : [],
        ...isConditionalFeature(hasFooterLinksRule, state) ? [{
          name: FOOTER_MODULE_NAME,
        }] : [],
      ]))]
    );
    await Promise.all(resolution.filter((result) => result.status === 'rejected')
      .map(async (result) => {
        dispatch(addErrorToReport(result.reason, {
          collectionMethod: 'loadModuleData rejected',
          moduleID: MODULE_NAME,
          caught: true,
        }));
      }));
  } catch (e) {
    dispatch(addErrorToReport(e, {
      collectionMethod: 'loadModuleData error',
      moduleID: MODULE_NAME,
      caught: false,
    }));
  }
};
